import React, { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
import { UserContext } from "../context/UserContext"; 

function Notifications() {
  const navigate = useNavigate();
  const { user, fetchUserData } = useContext(UserContext);
  
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(false);

  const userId = user?._id || user?.id || localStorage.getItem("userId");

  // --- 1. FETCH NOTIFICATIONS ---
  const fetchNotifications = useCallback(async () => {
    try {
      if (!userId) return;
      const response = await fetch(`${API_URL}/api/notifications/${userId}`);
      const data = await response.json();

      if (data.success) {
        setNotifications(data.notifications || []);
      }
    } catch (err) {
      console.error("Notification Error:", err);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  // --- 2. MARK AS READ (Manual Only) ---
  const markAsRead = useCallback(async () => {
    if (!userId) return;
    setMarking(true);

    try {
      await fetch(`${API_URL}/api/notifications/mark-read/${userId}`, {
        method: "PUT"
      });

      // Navbar update karo
      await fetchUserData(); 

      // UI update karo
      setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));

    } catch (error) {
      console.error("Error marking read:", error);
    } finally {
      setMarking(false);
    }
  }, [userId, fetchUserData]);

  // --- 3. EFFECTS (Auto-Read Removed ❌) ---
  useEffect(() => {
    if (userId) {
      fetchNotifications();
      // ❌ Maine yahan se setTimeout hata diya hai.
      // Ab ye automatic nahi chalega.
    }
  }, [userId, fetchNotifications]);

  const getNotificationStyle = (type) => {
    switch (type?.toLowerCase()) {
      case "deposit": return { icon: "wallet2", color: "#1cc88a", bg: "rgba(28, 200, 138, 0.1)" };
      case "withdrawal": return { icon: "bank", color: "#e74a3b", bg: "rgba(231, 74, 59, 0.1)" };
      case "contest_join": return { icon: "trophy-fill", color: "#f6c23e", bg: "rgba(246, 194, 62, 0.1)" };
      case "bonus": return { icon: "gift-fill", color: "#4e73df", bg: "rgba(78, 115, 223, 0.1)" };
      default: return { icon: "bell-fill", color: "#858796", bg: "#f8f9fc" };
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", { month: "short", day: "numeric" }) + 
           " • " + 
           date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="min-vh-100" style={{ background: "#f8f9fc" }}>
      
      {/* HEADER */}
      <div className="bg-white shadow-sm sticky-top px-3 py-3 d-flex align-items-center justify-content-between" style={{zIndex: 100}}>
         <div className="d-flex align-items-center gap-3">
             <button onClick={() => navigate(-1)} className="btn btn-light rounded-circle shadow-sm border-0 d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <i className="bi bi-arrow-left text-dark fs-5"></i>
             </button>
             <h5 className="fw-bold mb-0 text-dark">Notifications</h5>
         </div>
         
         {/* ✅ Ye Button ab zaroori hai read karne ke liye */}
         <button 
            className="btn btn-link text-decoration-none fw-bold small text-primary" 
            onClick={markAsRead}
            disabled={marking}
         >
            {marking ? "Clearing..." : "Mark all read"}
         </button>
      </div>

      <div className="container py-4" style={{ maxWidth: "600px" }}>

        {loading && <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>}

        {!loading && notifications.length === 0 && (
          <div className="text-center py-5 mt-4">
            <div className="bg-white rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm mb-3" style={{width: '80px', height: '80px'}}>
              <i className="bi bi-bell-slash text-muted opacity-50 display-6"></i>
            </div>
            <h6 className="fw-bold text-dark">No Notifications</h6>
          </div>
        )}

        <div className="d-flex flex-column gap-3">
          {notifications.map((notif) => {
            const style = getNotificationStyle(notif.type);
            const isUnread = notif.isRead === false;

            return (
              <div 
                key={notif._id} 
                className="card border-0 shadow-sm rounded-4 overflow-hidden position-relative"
                style={{ background: isUnread ? "#fff" : "#f8f9fa", opacity: isUnread ? 1 : 0.8 }}
              >
                {/* Unread Indicator */}
                {isUnread && <div className="position-absolute top-0 start-0 bottom-0 bg-primary" style={{width: "4px"}}></div>}

                <div className="card-body p-3">
                  <div className="d-flex gap-3">
                    <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: "50px", height: "50px", backgroundColor: style.bg, color: style.color }}>
                      <i className={`bi bi-${style.icon} fs-4`}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start mb-1">
                        <h6 className={`mb-0 fw-bold ${isUnread ? "text-dark" : "text-secondary"}`} style={{fontSize: '0.95rem'}}>{notif.title}</h6>
                        <small className="text-muted ms-2" style={{fontSize: '0.65rem', whiteSpace: 'nowrap'}}>{formatDate(notif.createdAt)}</small>
                      </div>
                      <p className="text-muted mb-0 small" style={{ lineHeight: "1.4", fontSize: '0.85rem' }}>{notif.message}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
}

export default Notifications;